import DOMPurify from 'dompurify';

function sanitizeHtml(htmlContent, config) {
    return {__html: DOMPurify.sanitize(htmlContent, config)};
}
 
export default sanitizeHtml;